import React, { useEffect, useState } from 'react';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
export function SocialProof() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const stepTime = Math.abs(Math.floor(duration / steps));
    const target = 2400;
    let current = 0;
    const timer = setInterval(() => {
      current += target / steps;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, stepTime);
    return () => clearInterval(timer);
  }, []);
  const avatars = ['https://cdn.magicpatterns.com/uploads/isMQE275ibEtfBUunbCo1x/TESTIMONIO_compressed_high.png', 'https://cdn.magicpatterns.com/uploads/2PsjdhDaJdo9poUCpc5ZbQ/TESTIMONIO_1_compressed_high.png', 'https://cdn.magicpatterns.com/uploads/mu1DwDhnB3gRfLKUPhEkF1/Imagen_del_HERO.png' // Reusing hero for 3rd avatar as placeholder
  ];
  return <div className="bg-[#0f3028] border-y border-cream/10 py-3 md:py-4" data-id="element-498">
      <div className="container mx-auto px-5 max-w-[1200px]" data-id="element-499">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-4 lg:gap-4 text-sm" data-id="element-500">
          {/* Left: Avatars & Count */}
          <div className="flex items-center gap-4" data-id="element-501">
            <div className="flex -space-x-3" data-id="element-502">
              {avatars.map((src, i) => <img key={i} src={src} alt="Avatar" className="w-10 h-10 rounded-full border-2 border-[#0f3028] object-cover" data-id="element-503" />)}
            </div>
            <div data-id="element-504">
              <div className="font-bold text-cream" data-id="element-505">
                +{count.toLocaleString()} mujeres ya lo han logrado
              </div>
              <div className="text-sand/70 text-xs" data-id="element-506">
                Comunidad activa en España y Latinoamérica
              </div>
            </div>
          </div>

          {/* Center: Stars */}
          <div className="flex items-center gap-3" data-id="element-507">
            <div className="flex items-center gap-1" data-id="element-508">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-peach text-peach" data-id="element-509" />)}
            </div>
            <div className="text-cream font-medium" data-id="element-510">
              4.9 / 5{' '}
              <span className="text-sand/70 font-normal" data-id="element-511">
                · 318 valoraciones
              </span>
            </div>
          </div>

          {/* Right: Guarantee */}
          <div className="flex items-center gap-2 text-sand/90" data-id="element-512">
            <ShieldCheckIcon className="w-4 h-4 text-peach" data-id="element-513" />
            <span data-id="element-514">Avalado por mujeres reales · Garantía de 30 días</span>
          </div>
        </div>
      </div>
    </div>;
}